// Usage:   <a href='' pdod-link="id=2504&pageid=5347" target="_blank">Math 2</a>
angular.module('rightPaneModule')
  .directive('pdodLink', ['$location', '$window', 'dblIaplService', 'configuration', function($location, $window, $dblIaplService, $configuration) {
    return {
      link: function(scope, element, attrs) {

          var iaplService = $dblIaplService;
          var hostUrl = $configuration.getIaplMoodleRedirectUrl();

          var isMoodleLink = function(url) { //assume moodle link will always use query strings
            return url.indexOf("http") === -1;
          };

          var selectViewPagePath = function(level) {
            if (level && level === 'course') {
               return $configuration.getMoodleCourseViewPage();
            }
            else {
               return $configuration.getMoodleLessonViewPage();
            }
          };

          var getRedirectUrl = function(pdodLink, accessIdResponse, level) {
            if (accessIdResponse.errorMessage !== null) {
                console.log("Moodle auth failed: " + accessIdResponse.errorMessage);

                $dblIaplService.logPdEvent('Moodle Auth Failed', {
                   label: accessIdResponse.errorMessage
                });
             }
             return hostUrl + '?id=' + accessIdResponse.accessId + '&redirect=' + $window.encodeURIComponent(selectViewPagePath(level) + pdodLink);
          };

          var redirectTo = function(url) {
            console.log("Redirect to " + url);
            $window.open(url, attrs.target);
          };

          element.on("click", function() {
             var link = attrs.pdodLink;
             $dblIaplService.logPdEvent('Select ' + (isMoodleLink(link) ?  'PD' : 'TT'), {
               label: attrs.lessonGroupName + ', ' + link
             }, attrs.assignFocusIncluded);

            var tab = $window.open('', attrs.target); // create a tab first, otherwise the browser will try to block it.
            if (tab) {
              tab.focus();
            }

            if (!isMoodleLink(attrs.pdodLink)) {
              redirectTo(attrs.pdodLink);
            } else {
                redirectTo('/x/pd-course-access?' + link);
       //       iaplService.getAccessId(function(accessIdResponse) {
       //         var url = getRedirectUrl(attrs.pdodLink, accessIdResponse, attrs.pdodLevel);
       //         redirectTo(url);
       //       });
            }
          });
        } // end of link
    };
  }]);
